// extracted by mini-css-extract-plugin
module.exports = {"time":"VodTile_time__hkloF","title":"VodTile_title__3-2vu"};